import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UserStore from '../../src/store/UserStore';
import { jwtDecode } from 'jwt-decode';
import { BASE_URL } from '../constant/const';

const PrivateRoute = ({ children }) => {
  const auth_data = UserStore((state) => state.user);
  let token = auth_data || null;
  const location = useLocation();
  if (!token) {
    //return <Navigate to="http://192.241.158.206/" />;
    //window.location.href = '/';
    return <Navigate to="/" state={{ from: location}} replace />;
  }
  const decodedToken = jwtDecode(token);
  const handleLogout = () => {
    const clearUser = UserStore.getState().clearUser;
    clearUser();
    localStorage.clear();
    //window.location.href = '/';
    return <Navigate to="/" state={{ from: location}} replace />;
  };

  if (!token) {
    handleLogout();
    return <Navigate to="/" state={{ from: location}} replace />;
    //return <Navigate to="/" />;
  }

  try {
    
    const currentTime = Math.floor(Date.now() / 1000);

    if (decodedToken.exp < currentTime || decodedToken?.user_data?.isActive==false) {
      handleLogout();
      return <Navigate to="/" state={{ from: location}} replace />;
    }

  } catch (error) {
    // console.error("Invalid token", error);
    handleLogout();
    return <Navigate to="/" state={{ from: location}} replace />;
  }

  return children;
};


export default PrivateRoute;